module.exports = __webpack_public_path__ + "img/arrow_down.3d9110d3.svg";